"use client";

import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import { ChevronDown } from "lucide-react";

const languages = [
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "tr", name: "Türkçe", flag: "🇹🇷" },
];

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const changeLanguage = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
    if (typeof window !== "undefined") {
      localStorage.setItem("i18nextLng", languageCode);
    }
  };

  const currentLanguage =
    languages.find((lang) => lang.code === i18n.language) ?? languages[0];

  return (
    <Select value={currentLanguage.code} onValueChange={changeLanguage}>
      <SelectTrigger className="relative h-11 w-11 justify-center rounded-full border border-orange-200 bg-white p-0 text-base shadow-sm hover:bg-orange-50 [&>svg]:hidden">
        <span className="leading-none">{currentLanguage.flag}</span>
        <ChevronDown className="pointer-events-none absolute bottom-1 right-1 h-3.5 w-3.5 text-slate-500" />
      </SelectTrigger>
      <SelectContent className="border-slate-200 bg-slate-50 text-slate-700">
        {languages.map((language) => (
          <SelectItem
            key={language.code}
            value={language.code}
            className="pl-3 pr-3 data-[state=checked]:text-slate-900"
          >
            <span className="flex items-center gap-2 truncate">
              <span>{language.flag}</span>
              <span>{language.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
